export default function getDefaultState () {
  return {
    drawer: null,
    productsDrawer: null,
    loading: {}
  }
}
